import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import MdmIcon from '../components/atoms/Global/MdmIcon.vue';
Vue.component('mdm-icon', MdmIcon);